export default __webpack_public_path__ + "static/media/banner1.e20ed75c.jpg";